import { TYPES, options } from './constants';

import { ToastProps } from './types';
import i18n from 'locals/i18n';
import { toast as showToast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const useToastNotification = () => {
	const { t } = useTranslation();
	const showNotification = ({ message, type, details, error }: ToastProps) => {
		let fullMessage = message || '';

		if (type === TYPES.ERROR) {
			if (details) {
				fullMessage = details;
			} else if (error) {
				const userFriendlyError = extractUserFriendlyError(error);
				if (userFriendlyError) {
					fullMessage = userFriendlyError;
				}
			}
		}

		switch (type) {
			case TYPES.INFO:
				return showToast.info(fullMessage, options);
			case TYPES.ERROR:
				return showToast.error(fullMessage, options);
			case TYPES.SUCCESS:
				return showToast.success(fullMessage, options);
			default:
				break;
		}
	};

	// Función para extraer errores amigables para el usuario (sin información técnica)
	const extractUserFriendlyError = (error: any): string | null => {
		if (!error) return null;

		// Si es un string, devolverlo directamente
		if (typeof error === 'string') return error;

		// Si tiene una propiedad message
		if (error.message) return error.message;

		// Si es una respuesta de API con error, solo mostrar mensajes útiles
		if (error.response?.data?.message) return error.response.data.message;
		if (error.response?.data?.error) return error.response.data.error;

		// No mostrar códigos de estado HTTP ni información técnica
		// if (error.response?.statusText) return `${error.response.status}: ${error.response.statusText}`;

		// Si tiene una propiedad error
		if (error.error) return error.error;

		// Si es un objeto, intentar convertirlo a string
		try {
			return JSON.stringify(error);
		} catch {
			return 'An unexpected error occurred. Please try again.';
		}
	};
	return {
		showNotification,
		TYPES,
		t,
	};
};

export const toastError = (message: string) => showToast.error(i18n.t(message), options);
export const toastSuccess = (message: string) => showToast.success(i18n.t(message), options);

export { useToastNotification };
